export default "__VITE_ASSET__1e144e61__"